import { useTranslation } from "react-i18next";
import { Text } from "../../base";
import styles from "./GreetingSection.module.css";

export interface GreetingSectionProps {
  userName?: string | null;
  show: boolean;
}

export const GreetingSection = ({ userName, show }: GreetingSectionProps) => {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div className={styles["greeting-section"]}>
      <Text variant="title" as="h2">
        {t("greeting.hello", { name: userName })}
      </Text>
    </div>
  );
};

